import { render } from "./TraillerView.vue?vue&type=template&id=087e12fa&scoped=true"
import script from "./TraillerView.vue?vue&type=script&lang=js"
export * from "./TraillerView.vue?vue&type=script&lang=js"

import "./TraillerView.vue?vue&type=style&index=0&id=087e12fa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-087e12fa"]])

export default __exports__